import {
  Box,
  Container,
  Collapse,
  Stack,
  SxProps,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import FromTo from "./FromTo/FromTo";
import TripTypeSelector from "./TripTypeSelector/TripTypeSelector";
import Who from "./Who/Who";
import SearchButton from "./SearchButton/SearchButton";
import { useSelector } from "react-redux";
import {
  changeFlights,
  changeIsValid,
  searchFormSelector,
} from "redux/searchForm";
import { UseAppDispatch } from "redux/store";
import { validateSearchForm } from "validation/validateSearch";
import { ISearchFormValidation } from "validation/validation.interfaces";
import { resetFilters } from "components/Filters/FilterOptions/resetFilters";
import { filterSelector } from "redux/filters/filters.selector";
import { setEntireFilters } from "redux/filters/filters.slice";
import { useTranslations } from "hooks/useTranslations";
import { isDiff } from "@thekilroygroup/shared-ui";
import { LowpriceCalendarLink } from "../LowPriceCalendar/Navigation/LowpriceCalendarLink";

interface IProps {
  variation?: "header" | undefined;
  handleSubmit: (e: React.MouseEvent) => void;
  showLowpriceCalendarLink?: boolean;
  showTriptypeSelector?: boolean;
  navigateToLowpriceCalendar?: () => void;
}
export default function Search(props: IProps) {
  const { flights } = useSelector(searchFormSelector);
  const {
    variation = false,
    navigateToLowpriceCalendar = () => {},
    handleSubmit = (e: React.MouseEvent) => {},
    showLowpriceCalendarLink = true,
    showTriptypeSelector = true,
  } = props;

  const dispatch = UseAppDispatch();
  const allFilters = useSelector(filterSelector);
  const searchForm = useSelector(searchFormSelector);
  const { translations } = useTranslations();
  const { breakpoints } = useTheme();
  const { nextFlights, isValid }: ISearchFormValidation =
    validateSearchForm(flights);

  const submitForm = (e: React.MouseEvent) => {
    dispatch(changeFlights(nextFlights));
    dispatch(changeIsValid(isValid));
    if (isValid) {
      const { initialFilters, filters } = resetFilters(
        searchForm,
        allFilters,
        translations,
      );

      if (isDiff(initialFilters, filters)) {
        dispatch(setEntireFilters(initialFilters));
      }
      handleSubmit(e);
    }
  };

  const isMobile = useMediaQuery(breakpoints.down("md"));
  return (
    <form action="">
      {showTriptypeSelector && (
        <Box
          sx={{
            ...(variation === "header" && sxStyles.tripTypeSelectorWrapper),
          }}
        >
          <Container maxWidth="lg" sx={sxStyles.container}>
            <TripTypeSelector />
          </Container>
        </Box>
      )}
      <Container
        maxWidth="lg"
        sx={{ ...sxStyles.wrapper, maxWidth: breakpoints.values.lg }}
      >
        <Stack direction={isMobile ? "column" : "row"}>
          <FromTo />
          <Who />
          <Box sx={sxStyles.buttonWrapper}>
            <SearchButton handleSubmit={submitForm} />
            <Collapse in={isValid && isMobile && showLowpriceCalendarLink}>
              <LowpriceCalendarLink
                handleNavigate={navigateToLowpriceCalendar}
                searchForm={searchForm}
                variant="text"
                size="small"
                sx={{ mt: 1, width: "100%" }}
              />
            </Collapse>
          </Box>
        </Stack>
      </Container>
    </form>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  tripTypeSelectorWrapper: {
    backgroundColor: "primary.main",
    "& .MuiTab-root": {
      color: "white.main",
    },
    "& .MuiTab-root.Mui-selected": {
      color: "white.main",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "white.main",
    },
  },
  container: {
    pb: 1,
    mb: 1,
  },
  buttonWrapper: {
    my: 1,
    mx: 0,
    width: "100%",
    ml: { md: 2 },
  },
  wrapper: {
    width: 1,
    margin: "0 auto",
  },
};
